import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { ERROR_500 } from 'routes/paths';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {}

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      this.setState({ hasError: false });
      return <Route path="/" element={<Navigate replace to={ERROR_500} />} />;
    }
    return children;
  }
}

export default ErrorBoundary;
